var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#007AC9",
  fillRule: "evenodd",
  d: "M17 21c.2-.2.6-.2.8 0l5.6 2.4c.6 1 1 2 1.6 2.8v15l7.6-2.4-1.4-6.8c.4-.6 1-1.4 1.4-2.4l1.6 9.4 7.2 2.2-5.2-15.8-1-.4c.6-.4.8-1 1.2-1.4l1.2.4c.2.2.4.4.4.6l6 17.8c.2.4 0 .6-.2 1-.2.2-.4.2-.6.2H43l-9.2-2.8-9.2 2.8H24l-9.2-2.8-9.2 2.8c-.4 0-.6 0-1-.2-.6-.2-.6-.6-.6-.8l6-17.8c0-.4.2-.6.4-.8zm-3.4 18.2-7.2 2.2 5.2-15.8 4.6-2zm9.4 2.4-7.6-2.4 2.6-16 4.8 2.2v16.2z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#007AC9",
  fillRule: "evenodd",
  d: "M37.4 13.8c0 4.4-7.4 15.6-7.4 15.6S22.4 18 22.4 13.8 25.8 6 29.8 6s7.6 3.4 7.6 7.8m-4.2-.4c0-1.8-1.4-3.4-3.4-3.4-1.8 0-3.4 1.4-3.4 3.4 0 1.8 1.4 3.4 3.4 3.4 1.8 0 3.4-1.4 3.4-3.4",
  clipRule: "evenodd"
})));
export { SvgMap as ReactComponent };